import {ImportDataComponent, ImportDataComponentProps} from "@components/shared/ImportDataComponent.tsx";
import React from "react";
import usePublic from "@shared/hooks/usePublic.ts";
import {IFornecedor} from "@models/fornecedores/fornecedor.ts";
import {useFornecedor} from "@components/fornecedores/hooks/useFornecedor.ts";
import {ICreateFornecedorDto} from "@models/fornecedores/dto/ICreateFornecedorDto.ts";
import {ToCpfCnpj} from "@shared/ValidationHelp.ts";

interface ImportFornecedoresComponentProps {
    onCreate: (v?: IFornecedor[]) => void
}

export function ImportFornecedoresComponent(props: ImportFornecedoresComponentProps) {
    const {onCreate} = props;
    const {getTemplate} = usePublic()
    const {importFornecedores} = useFornecedor()

    const importProps: ImportDataComponentProps<ICreateFornecedorDto, IFornecedor> = {
        onCreate: onCreate,
        filename: "fornecedor.csv",
        importMethod: importFornecedores,
        previewGrid: [
            {field: "idErp", headerName: 'Id no ERP', width: 200},
            {field: 'nome', headerName: 'Nome/Apelido', width: 100},
            {
                field: "cpfCnpj", headerName: 'CNPJ', width: 200, renderCell: (params) => {
                    if (params.value) {
                        return ToCpfCnpj(params.value)
                    }
                    return ''
                }
            },
            {field: 'razaoSocial', headerName: 'Razao Social', width: 150},
            {field: "nomeFantasia", headerName: 'Nome Fantasia', width: 200},
            {field: "inscricaoEstadual", headerName: 'Inscrição estadual', width: 200},
        ],
        templateUrl: getTemplate('fornecedor', 'import-example'),
    }

    return (
        <ImportDataComponent {...importProps}/>
    )
}